export default "A: hey, you good?\nB: not really tbh\nA: wanna talk about it\nB: maybe later, just need to vibe rn\nA: okay just lmk\n"